<template>
  <!-- Modal -->
  <div class="modal fade" id="SingleConsignmentOrdersModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <vue-element-loading :active="isSearching" spinner="bar-fade-scale" color="#333"/>
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">売上登録</h5>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body">
          <div v-if="displayWarning" class="alert alert-danger">月末の登録になるため、登録日をご確認ください</div>
          <div>
            <table class="table table-striped table-align-middle">
              <thead>
                <tr>
                  <th>登録日</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input v-model="shippingAt" type="date" class="form-control" @blur='changeShippingAt' @focus="tempDateField = shippingAt">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="table-scroll">
          <table class="table table-striped table-align-middle">
            <thead>
              <tr>
                <th>JANコード</th>
                <th>型番</th>
                <th>個数</th>
                <th>単価</th>
                <th>発注番号</th>
                <th>倉庫名</th>
                <th>区分</th>
                <th>在庫数</th>
                <th>売上数量</th>
              </tr>
            </thead>
            <tbody class="nowrap">
              <template v-for="(product, i) in warehouseProducts">
              <tr :key="i">
                <td>{{product.isShowJanCode ? product.jan_code : ''}}</td>
                <td>{{product.isShowJanCode ? product.type_number : ''}}</td>
                <td class="right">{{product.isShowJanCode ? product.quantity.toLocaleString() : ''}}</td>
                <td class="right"><input v-model="product.unit_price" class="form-control form-control-sm" type="text" placeholder="0" min-value="0"></td>
                <td>{{product.isShowJanCode ? product.client_order_number : ''}}</td>
                <td>{{product.warehouse_name}}</td>
                <td>{{Number(product.defective) === 1 ? '不良品' : '良品'}}</td>
                <td class="right">{{product.stock_quantity.toLocaleString()}}</td>
                <td>
                  <input v-model="product.shippingQuantity" class="form-control form-control-sm" type="text" placeholder="0" min-value="0">
                </td>
              </tr>
              </template>
            </tbody>
          </table>
          </div>
        </div>
        <div class="modal-footer">
          <button ref="closeModal" type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          <button type="button" class="btn btn-primary" @click="addShipping">更新</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'

export default {
  name: 'SingleConsignmentOrdersModal',
  components: {
    VueElementLoading
  },
  props: {
    // buttonType: null,
    outsourcingStatus: null,
    orderID: Number
  },
  data () {
    return {
      shippingAt: '',
      displayWarning: false,
      isSearching: false,
      warehouseProducts: [],
      tempDateField: ''
    }
  },
  created () {
    this.shippingAt = new Date().toISOString().slice(0, 10)
  },
  mounted () {
    window.$('#SingleConsignmentOrdersModal').on('shown.bs.modal', () => {
      this.listWarehouseProducts()
      window.$('#SingleConsignmentOrdersModal').find('.table-scroll').css('height', (window.innerHeight - 400) + 'px')
    })
  },
  watch: {
    shippingAt: {
      handler: function (data, oldData) {
        if (Number(data.substr(8, 2)) >= 25) {
          this.displayWarning = true
        } else {
          this.displayWarning = false
        }
      }
    }
  },
  computed: {
  },
  methods: {
    showWarning () {
      let date = new Date().getDate()

      this.displayWarning = (date >= 25)
    },

    changeShippingAt () {
      if (this.tempDateField === this.shippingAt) return
      if (!this.shippingAt) {
        this.shippingAt = new Date().toISOString().slice(0, 10)
      }
      if (!this.tempDateField) {
        this.tempDateField = this.shippingAt
      }

      this.listWarehouseProducts()
    },

    async listWarehouseProducts (closeModal) {
      this.isSearching = true

      const pramas = {
        orders_id: this.orderID,
        shipped_at: this.shippingAt
      }

      try {
        let response = await this.$http.post(this.$api_url.orders_consignment_warehouse_products, pramas)
        let $data = this.$invoiceTools.prepareResult(response.data, 'item_list', 'SingleConsignmentOrdersModal:listWarehouseProducts')
        if ($data.success === true) {
          this.warehouseProducts = $data.data
        } else {
          this.warehouseProducts = []
          this.$toastr.error($data.data, 'エラー')
        }
        this.initializeShippingQuantitys()
        this.isSearching = false
        if (closeModal) this.$refs.closeModal.click()
      } catch (error) {
        console.log('SingleConsignmentOrdersModal:listWarehouseProducts:catch(error): ', error)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isSearching = false

        this.initializeShippingQuantitys()
      }
    },

    initializeShippingQuantitys () {
      let currentProductId = ''
      let currentJanCode = ''
      let currentTypeNumber = ''
      let currentQuantity = 0
      let currentClientOrderNumber = ''
      let currentUnitPrice = 0
      this.warehouseProducts.forEach(function (product, index) {
        if (product.warehouse_id === product.mainwarehouse_id && !product.defective) {
          product.shippingQuantity = product.quantity
        } else {
          product.shippingQuantity = 0
        }
        if (currentProductId === product.product_id && currentJanCode === product.jan_code && currentTypeNumber === product.type_number && currentQuantity === product.quantity && currentClientOrderNumber === product.client_order_number && currentUnitPrice === product.unit_price) {
          product.isShowJanCode = false
        } else {
          currentProductId = product.product_id
          currentJanCode = product.jan_code
          currentTypeNumber = product.type_number
          currentQuantity = product.quantity
          currentClientOrderNumber = product.client_order_number
          currentUnitPrice = product.unit_price
          product.isShowJanCode = true
        }
      })
    },

    async addShipping () {
      if (this.shippingAt === '') {
        this.$toastr.warning('登録日をご入力ください')
        return
      }

      try {
        let quantityError = false
        this.isSearching = true
        let productList = []
        let self = this
        let price
        let priceInctax
        this.warehouseProducts.forEach(function (product) {
          if (Number(product.shippingQuantity) > 0) {
            if (Number(product.shippingQuantity) > Number(product.stock_quantity)) { // 売上数量 > 在庫数
              quantityError = true
              return // CONTINUE
            }
            if (self.$parent.taxIncluded === 1) {
              price = self.$util.getExcludeTax(product.unit_price, self.$parent.taxRate)
              priceInctax = product.unit_price
            } else {
              price = product.unit_price
              priceInctax = self.$util.getIncludeTax(product.unit_price, self.$parent.taxRate)
            }
            productList.push({
              detail_id: product.detail_id,
              warehouse_id: product.warehouse_id,
              defective: product.defective,
              product_id: product.product_id,
              jan_code: product.jan_code,
              type_number: product.type_number,
              unit_price: price,
              unit_price_inctax: priceInctax,
              client_order_number: product.client_order_number,
              quantity: Number(product.shippingQuantity),
              younosuke_company_id: self.$parent.tempInfo.client_id
            })
          }
        })
        if (quantityError) {
          this.isSearching = false
          this.$toastr.warning('在庫数以下の売上数量を入力してください。')
          return
        }

        let params = {
          orders_id: this.orderID,
          shipping_at: this.shippingAt,
          product_list: productList
        }
        let response = await this.$http.post(this.$api_url.orders_confirm_consignment_sales, params)
        console.log('SingleConsignmentOrdersModal:response', response)
        if (response.data.status === true) {
          this.$toastr.success('委託売上を登録しました。', 'Success')
          // this.$parent.ordersInfo.sales_status = 1 // 0:未登録, 1:未請求, 2:請求済み // 在庫がなくなるまで再登録を許す
          this.listWarehouseProducts(true) // CLOSE MODAL
        } else {
          this.$toastr.error(response.data.message, 'エラー')
        }
        this.isSearching = false
      } catch (error) {
        console.log('SingleOrders:updateOrders:catch(error): ', error)
        this.$toastr.error('売上登録がエラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
        this.isSearching = false
      }
    }
  }
}
</script>
